<template>
    <transition enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut fastest">
        <div class="tw-fixed ncsa-guest-popup tw-max-w-md tw-bg-white tw-shadow-md tw-p-10 tw-overflow-scroll" v-if="visible">
            <button @click="dismiss" class="tw-absolute tw-cursor-pointer closeBtn">
                <i class="fas fa-times"></i>
            </button>

            <img src="/img/logos/black-on-transparent-horizontal.png" class="tw-mb-10">

            <h3 class="tw-text-3xl tw-mb-5 tw-text-black">Interested in incorporating Blast into your team or organization?</h3>

            <p class="tw-mb-10 tw-text-black">Blast offers a variety of starter packages to fit your coaching needs.</p>

            <button type="button" class="btn btn-primary" @click="learnMore">Learn More</button>

            <button type="button" class="btn btn-link" @click="cancel">No Thanks</button>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
    .ncsa-guest-popup {
        bottom: 80px;
        right: 20px;
        z-index: 9999;

        .closeBtn {
            top: 25px;
            right: 25px;
        }

        img {
            max-width: 120px;
        }

        @media only screen and (max-width: 480px) {
            // top: 20px;
            left: 20px;
            bottom: 20px;
        }
    }
</style>

<script>
    export default {
        name: 'NcsaGuestPopup',

        data() {
            return {
                visible: true,
            }
        },

        methods: {
            dismiss() {
                trackEvent('ga-ncsa-clicked-dismiss-popover-public-profile');

                this.visible = false;
            },

            cancel() {
                trackEvent('ga-ncsa-clicked-no-thanks-public-profile');

                this.visible = false;
            },

            learnMore() {
                trackEvent('ga-ncsa-clicked-learn-more-public-profile');

                window.axiosV2.patch('ncsa-profile-visit-update', {
                    status: true,
                })
                .catch((error) => console.error(error))
                .then(() => {
                    this.visible = false;

                    window.open('https://blastmotion.com/partner/baseball/ncsa/coach', '_blank');
                });
            }
        },

        created() {
            if (this.visible) {
                trackEvent('ga-ncsa-popover-presented-public-profile');
            }
        }
    }
</script>

